module.exports = __webpack_public_path__ + "static/enterprise-logo-a1106b579ffe0fab7b1a6ba943cf0286.svg";